<template>
  <div class="p-6 bg-white rounded-lg">
    <div class="flex items-center mb-4 pb-4 border-b">
      <div
        class="flex-no-shrink w-12 h-12 rounded-lg text-white p-1 bg-primary"
      >
        <icon class="text-white" name="percentage" />
      </div>
      <h3 class="text-2xl font-medium ml-4">
        Guild Discounts
      </h3>
    </div>
    <p class="text-base leading-tight mb-6">As a Member of The Guild of Property Professionals, you receive discount on this service. The amount of the discount depends on the plan you are on:</p>
    <p>Guild <strong class="text-guild-plan-green">STANDARD</strong> = From 5% to 20% Discount</p>
    <p>Guild <strong class="text-guild-plan-orange">ENHANCED</strong> = From 10% to 20% Discount</p>
    <p class="mb-4">Guild <strong class="text-guild-plan-purple">PREMIUM</strong>  = From 15% to 20% Discount</p>
    <p class="mb-4">Upgrading couldn't be easier. Simply follow, the link below, to learn more</p>
    <button
      class="mb-2 p-3 inline-block no-underline bg-secondary button-text-color text-center text-sm w-full rounded uppercase"
    >
      <router-link to="/guild-plan" tag="button">Upgrade My Plan</router-link>
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: ['module'],

  computed: {
    ...mapState(['selectedOffice'])
  },
  methods: {
  }
}
</script>
